import React from 'react';
import PropTypes from 'prop-types';

import Shadow from 'pages/Configurators/styles/Shadow';

import FocusedElement from '../../../../../components/FocusedElement';

import ContextMenu from '../ContextMenu';

const Username = props => {
  const { name, options, animation } = props;

  return (
    <FocusedElement style={{ textAlign: options.styles.textAlign }}>
      <Shadow style={{ margin: 0, ...options.styles, backfaceVisibility: 'hidden' }}>
        ================================
      </Shadow>
      <p
        id={`${name}__screen_element`}
        className={animation}
        style={{
          margin: 0,
          ...options.styles,
          backfaceVisibility: 'hidden',
          display: 'inline-block',
        }}
      >
        Tipply
      </p>

      <ContextMenu elementName={name} fields={['editText', 'animation']} />
    </FocusedElement>
  );
};

Username.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.instanceOf(Object).isRequired,
  animation: PropTypes.string.isRequired,
};

export default Username;
